export const typesRedux = {
    //Auth
    AUTH_LOGIN: '[Auth Login] Load user login data',
    LOGOUT_LOGIN: '[Logout Login] Delete loaded user session data',
    VALIDATION_TOKEN:
        '[Validation Token] Validate the user active session token',

    //General
    MODE_THEME: '[Mode Theme] Load app theme mode',
    USER_LOG: '[User Log] Load all information of the logged in user to redux',
};
